import { useEffect, useState } from "react";
import { Eye, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { toEmail } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Field, EmptyState } from "@/components/common";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function ViewerPage() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", username: "", password: "" });
  const [del, setDel] = useState(null);
  const load = () => api.get("/viewers").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/viewers", { name: f.name, email: toEmail(f.username), password: f.password }); toast.success("Akun viewer dibuat"); setOpen(false); setF({ name: "", username: "", password: "" }); load(); } catch (er) { toast.error(errMsg(er)); }
  };
  const toggle = async (v, active) => { try { await api.patch(`/viewers/${v.id}/status`, { active }); load(); } catch (e) { toast.error(errMsg(e)); } };
  const remove = async () => { try { await api.delete(`/viewers/${del.id}`); toast.success("Akun viewer dihapus"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="max-w-3xl">
      <div className="flex items-center justify-between gap-3 mb-5">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold">Akun Viewer</h1>
        <Button className="h-11 rounded-full" onClick={() => setOpen(true)} data-testid="add-viewer-button"><Plus className="h-4 w-4 mr-1" />Tambah Akun</Button>
      </div>
      {items === null ? <p className="text-muted-foreground">Memuat...</p> : items.length === 0 ? (
        <EmptyState icon={Eye} title="Belum ada akun viewer" text="Akun viewer hanya bisa melihat dashboard super admin." testId="viewers-empty" />
      ) : (
        <div className="space-y-3">
          {items.map((v) => (
            <div key={v.id} className="panel !p-4 flex items-center gap-3 min-w-0" data-testid={`viewer-${v.id}`}>
              <span className="h-10 w-10 rounded-full bg-primary/12 text-primary grid place-items-center font-bold shrink-0">{v.name[0]}</span>
              <div className="min-w-0 flex-1"><p className="font-semibold truncate">{v.name}</p><p className="text-xs text-muted-foreground truncate">{v.email}</p></div>
              <Switch checked={v.active} onCheckedChange={(a) => toggle(v, a)} data-testid={`viewer-toggle-${v.id}`} />
              <Button size="sm" variant="ghost" className="h-9 w-9 p-0 rounded-full text-rose-600" onClick={() => setDel(v)} data-testid={`viewer-delete-${v.id}`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          ))}
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="viewer-form">
          <DialogHeader><DialogTitle className="font-heading">Tambah Akun Viewer</DialogTitle></DialogHeader>
          <form onSubmit={add} className="space-y-4">
            <Field label="Nama"><Input required className="h-11" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="viewer-name-input" /></Field>
            <Field label="Username" hint={f.username ? toEmail(f.username) : "otomatis @kspbam.com"}><Input required className="h-11" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value.replace(/[^a-zA-Z0-9._-]/g, "").toLowerCase() })} data-testid="viewer-username-input" /></Field>
            <Field label="Password"><Input required minLength={8} type="password" className="h-11" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="viewer-password-input" /></Field>
            <Button type="submit" className="w-full h-11 rounded-full" data-testid="viewer-submit">Simpan</Button>
          </form>
        </DialogContent>
      </Dialog>
      <ConfirmDialog open={Boolean(del)} onOpenChange={(o) => !o && setDel(null)} title="Hapus Akun Viewer" danger confirmLabel="Ya, hapus" onConfirm={remove}
        description={del && <>Hapus akun <b>{del.name}</b>?</>} />
    </div>
  );
}
